import state from "./state";
import actions from "./actions";
import mutations from "./mutations";

const getters = {
  getTeacherYearlyAttendanceExportList: (state) => state.items,
  getTeacherYearlyAttendanceExportListPagination: (state) => state.pagination,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
